import { createAction } from 'redux-actions';

const setLoading = createAction('SET_LOADING');

export default setLoading;
